<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 60px;
        background-image: url(img/theme/profile-cover.jpg);
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <!-- <h1 class="display-2 text-white">Washing Machine</h1> -->
            <!-- <p class="text-white mt-0 mb-5"></p> -->
            <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
          </div>
        </div>
      </div>
    </base-header>
   <!-- <BlockUI :message="msg" :url="url"></BlockUI> -->

    <div id="ads" v-if="check !== true">
      <!-- <b-card> -->
      <div id="box">
        <p id="fontInBox">สำหรับผู้ใช้ระบบจอเท่านั้น</p>
        <iframe style="display: block; margin-left: auto; margin-right: auto;"
          id="vdo"
          src="https://www.youtube.com/embed/8IvK0QTW8gU"
          frameborder="0"
          allow="accelerometer; autoplay;"
          allowfullscreen
        >
        </iframe>
      </div>
    </div>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">จัดการโปรโมชั่น</h3>
                </div>
                <!-- <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                                </div> -->
              </div>
            </div>
            <template>
              <div class="pl-lg-4">
                <h6
                  class="heading-small text-muted mb-4"
                  style="font-size: 14px"
                >
                  ข้อมูลโปรโมชัน
                </h6>
                <base-switch
                  v-if="this.$route.params.id !== 'null'"
                  :value="switches"
                  class="ml-1"
                  @input="switches = Boolean($event)"
                  v-on:click="booleanData(switches)"
                >
                </base-switch>
                <form @submit.prevent>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        label="ชื่อโปรโมชั่น"
                        placeholder="ชื่อโปรโมชั่น"
                        input-classes="form-control-alternative"
                        v-model="namePro"
                      />
                    </div>

                    <div class="col-lg-6">
                      <!-- ลดราคา<br> -->
                      <base-input label="ลดราคา"
                        ><br />
                        <select class="form-control" v-model="price">
                          <!-- <option v-for="item in discount" :key="item.value" >{{item.text}}</option> -->
                          <!-- <option disabled value="">Please select one</option> -->
                          <option value="manual">กำหนดราคาเอง</option>
                          <!-- <option value="difference">กำหนดราคาส่วนต่างเอง</option> -->
                          <option value="5">5%</option>
                          <option value="10">10%</option>
                          <option value="15">15%</option>
                          <option value="20">20%</option>
                          <option value="25">25%</option>
                          <option value="30">30%</option>
                          <option value="40">40%</option>
                          <option value="50">50%</option>
                          <option value="60">60%</option>
                          <option value="70">70%</option>
                          <option value="80">80%</option>
                        </select>
                      </base-input>
                    </div>
                    <!-- <div class="col-lg-6">
                                           ลดราคา  {{sliders.slider1}} %<br>
                                      <base-slider v-model="sliders.slider1"></base-slider>

                                      </div> -->
                  </div>
                  <br />

<!--                   <div class="row">

                    <div class="col-lg-6">
                     
                      <base-input label="วันที่เริ่มต้น"
                        ><br />

                        <select class="form-control" v-model="dateStart" @change="onChangeProtime()">
                          <option v-for="item in options" :key="item.text">
                            {{ item.text }}
                          </option>
                        </select>
                        <div style="font-size:10pt; margin-top:10px; color: #d5310d;">{{promotion_time_message}}</div>
                       
                      </base-input>
                    </div>

                    <div class="col-lg-6">
                    
                      <base-input label="วันที่สิ้นสุด"
                        ><br />
                        <select class="form-control" v-model="dateEnd" @change="onChangeProtime()">
                          <option v-for="item in options" :key="item.text" >
                            {{ item.text }}
                          </option>
                        </select>

                      </base-input>
                    </div>

                   
                  </div>
 -->



                  <div class="row">


                    <div class="col-lg-2">
                      <!-- ตั้งแต่เวลา<br> -->
                     

                      
                              <input
                                type="checkbox"
                                v-model="isLimitDate"

                              />
                              <label > กำหนด วันเริ่ม-สิ้นสุด</label>
                           
                      </base-input>
                    </div>

      <!--               <div class="col-lg-3" v-if="isLimitDate">
                    

                      <base-input label="เริ่มวันที่"
                        ><br />
                        <date-picker v-model="time1" valueType="format" ></date-picker>
                        
                      </base-input>
                    </div> -->

                    <div class="col-lg-8" v-if="isLimitDate">
                      <!-- ถึงเวลา<br> -->
                      <base-input label="วันที่"
                        ><br />
                        <date-picker v-model="date_limit"  range></date-picker> 
                  
                        <!-- <label style="font-size: 10pt;" > ระยะเวลาโปรโมชั่น 7 วัน</label> -->
                      </base-input>
                    </div>

                   
                  </div>




                  <div class="row">

                    <div class="col-lg-6">
                      <!-- ตั้งแต่เวลา<br> -->
                    

                      <base-input label="ตั้งแต่เวลา"
                        ><br />

                        <select class="form-control" v-model="dateStart" @change="onChangeProtime()">
                          <option v-for="item in options" :key="item.text">
                            {{ item.text }}
                          </option>
                        </select>
                        <div style="font-size:10pt; margin-top:10px; color: #d5310d;">{{promotion_time_message}}</div>
                        <!-- <select style=" padding: 10px;" v-model="dateStart" >
                                              <option disabled value="">Please select one</option>
                                                  <option v-for="item in options" :key="item.text" >{{item.text}}</option>
                                                 </select> -->
                      </base-input>
                    </div>

                    <div class="col-lg-6">
                      <!-- ถึงเวลา<br> -->
                      <base-input label="ถึงเวลา"
                        ><br />
                        <select class="form-control" v-model="dateEnd" @change="onChangeProtime()">
                          <option v-for="item in options" :key="item.text" >
                            {{ item.text }}
                          </option>
                        </select>

                        <!-- <select v-model="dateEnd" style="padding: 10px; ">
                                              <option disabled value="">Please select one</option>
                                              <option v-for="item in options" :key="item.text">{{item.text}}</option>
                                               
                                            </select> -->
                      </base-input>
                    </div>

                   
                  </div>

<!--                    <div class='row' style="font-size:10pt; margin-right:1px; color: #d5310d;"> 
                      <div class="col-lg-12" >
                       {{promotion_time_message}}
                     </div>
                   </div>
                   <br />  -->

                  <div class='row' style="font-size:9pt; margin-right:1px;"> 
                   <div class="col-lg-12" >
                      <div>
                     <b>***ตัวอย่างการตั้งเวลาโปรโมชั่น***</b>  <br />  -EX1. ถ้าต้องการโปรโมชั่นเวลา เที่ยงคืน - หกโมงเช้า ให้ตั้งเป็น  00:00 - 06:00 <br />
                                              -EX2. ถ้าต้องการตั้งการโปรโมชั่น ทั้งวันทั้งคืน ให้ตั้งเป็น 00:00 - 00:00 <br />
                                              -EX3. ถ้าต้องการตั้งโปรโมชั่น ห้าทุ่ม-ตีห้า ให้ตั้งเป็น 23:00 - 05:00 
                       </div>
                    </div>
                  </div>


                  <!-- <br /> -->
                  <hr />

                  <div class="row">
                    <div class="col-lg-7">
                      <h6
                        class="heading-small text-muted mb-4"
                        style="font-size: 14px"
                      >
                        เลือกเครื่องซัก/อบที่ต้องการเข้าร่วมโปรโมชัน
                      </h6>
                      <div class="table-responsive">
                        <base-table
                          class="table align-items-center table-flush"
                          tbody-classes="list"
                          :data="dump"
                        >
                          <template slot="columns">
                            <th
                              class="text-center"
                              style="font-size: 14px; background-color: #f2f3f4"
                            >
                              รหัสเครื่อง
                            </th>
                            <th
                              class="text-center"
                              style="font-size: 14px; background-color: #f2f3f4"
                            >
                              ชื่อเครื่อง
                            </th>
                            <th v-if="price == 'manual'" class="text-center" style="font-size: 14px; background-color: #F2F3F4">
                              กำหนดราคาเอง
                            </th>
                            <th
                              class="text-center"
                              style="font-size: 14px; background-color: #f2f3f4"
                            >
                              ตั้งค่า<input
                                type="checkbox"
                                id="checkbox"
                                v-on:click="allSelect()"
                                v-model="all"
                              />
                            </th>
                          </template>

                          <template slot-scope="{ row }">
                            <th class="text-center" scope="row">
                              <div class="media align-items-center">
                                <div class="media-body">
                                  <span class="name mb-0 text-sm">{{
                                    row.name
                                  }}</span>
                                </div>
                              </div>
                            </th>
                            <td class="text-center">
                              {{ row.name_desc }}
                            </td>
                            <td class="text-center" v-if="price == 'manual' || price == 'difference'" >
                              <div v-for="(mode, index) of row.modes">
                                <div class="row">
                                  <div class="col-12">{{mode.mode_desc}}</div>
                                </div>
                                 <div class="row">
                                    <input onkeydown="javascript: return event.keyCode == 69 ? false : true" @keypress="isNumber($event)" class="col" size="1" type="number" :id="row.name + '' + index" v-model="data_mode[row.name + '_' + mode.mode_name]"   >
                                    {{initCustomPrice(data_mode[row.name + '_' + mode.mode_name])}}
                                    <!-- :disabled="(mode.mode_name=='M045' || mode.mode_name=='M046' || mode.mode_name=='M047' || mode.mode_name=='M048')" -->
                                    <!-- {{data_mode}} -->
                                 </div>
                              </div>
                            </td>
                            <td class="budget text-center">
                              <input
                                type="checkbox"
                                id="checkbox"
                                v-model="row.check"
                              />
                              <!-- <span> {{row.check }}</span> -->
                            </td>
                          </template>
                        </base-table>
                      </div>
                      <br />
                    </div>
                    <div class="col-lg-5">
                      <h6
                        class="heading-small text-muted mb-4"
                        style="font-size: 14px"
                      >
                        เลือกวันที่ต้องการ
                      </h6>
                      <div class="table-responsive">
                        <base-table
                          class="table align-items-center table-flush"
                          tbody-classes="list"
                          :data="day"
                        >
                          <template slot="columns">
                            <th
                              class="text-center"
                              style="font-size: 14px; background-color: #f2f3f4"
                            >
                              วันที่
                            </th>
                            <!-- <th class="text-center" style="font-size: 14px; background-color: #F2F3F4">สถานะ</th> -->
                            <th
                              class="text-center"
                              style="font-size: 14px; background-color: #f2f3f4"
                            >
                              ตั้งค่า<input
                                type="checkbox"
                                id="checkbox"
                                v-on:click="allSelectDay()"
                                v-model="allDay"
                              />
                            </th>
                          </template>

                          <template slot-scope="{ row }">
                            <th class="text-center" scope="row">
                              <div class="media align-items-center">
                                <div class="media-body">
                                  <span class="name mb-0 text-sm">{{
                                    row.text
                                  }}</span>
                                </div>
                              </div>
                            </th>

                            <!-- <td class="text-center"> -->
                            <!-- {{row.used}} -->
                            <!-- </td> -->
                            <td class="budget text-center">
                              <input
                                type="checkbox"
                                id="checkbox"
                                v-model="row.check"
                              />
                              <!-- <span> {{row.check }}</span> -->
                            </td>
                          </template>
                        </base-table>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="text-center">
                    <base-alert type="default" v-show="isLoading">
                      <i class="ni ni-world-2"></i> กำลังโหลดกรุณารอสักครู่...
                    </base-alert>
                    <button
                      class="btn btn-primary"
                      type="button"
                      name="button"
                      v-on:click="submit()"
                    >
                      บันทึก
                    </button>
                  </div>
                </form>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bCard from "bootstrap-vue/es/components/card/card";
import JwService from "../service/justwash";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/th';
import moment from 'moment'

export default {
  name: "setting-promotion",
  components: {
    bCard,
    DatePicker
  },
  data() {
    return {
      date_limit:new Date(),
      isLimitDate: false,
      vdata : 999,
      sliders: {
        slider1: 50,
      },
      all: false,
      allDay: false,
      namePro: null,
      price: 50,
      tableData: null,
      isLoading: false,
      options: [
        { text: "00.00" },
        { text: "01.00" },
        { text: "02.00" },
        { text: "03.00" },
        { text: "04.00" },
        { text: "05.00" },
        { text: "06.00" },
        { text: "07.00" },
        { text: "08.00" },
        { text: "09.00" },
        { text: "10.00" },
        { text: "11.00" },
        { text: "12.00" },
        { text: "13.00" },
        { text: "14.00" },
        { text: "15.00" },
        { text: "16.00" },
        { text: "17.00" },
        { text: "18.00" },
        { text: "19.00" },
        { text: "20.00" },
        { text: "21.00" },
        { text: "22.00" },
        { text: "23.00" },
        
      ],
      discount: [
        { text: "5%", value: 5 },
        { text: "10%" },
        { text: "15%" },
        { text: "20%" },
        { text: "25%" },
        { text: "30%" },
        { text: "40%" },
        { text: "50%", value: 50 },
        { text: "60%" },
        { text: "70%" },
        { text: "80%" },
      ],
      dateStart: "00.00",
      dateEnd: "00.00",
      promotion_time_message: "",
      dump: [],
      day: [
        { text: "จันทร์", check: false, textEng: "Monday" },
        { text: "อังคาร", check: false, textEng: "Tuesday" },
        { text: "พุธ", check: false, textEng: "Wednesday" },
        { text: "พฤหัสบดี", check: false, textEng: "Thursday" },
        { text: "ศุกร์", check: false, textEng: "Friday" },
        { text: "เสาร์", check: false, textEng: "Saturday" },
        { text: "อาทิตย์", check: false, textEng: "Sunday" },
      ],
      dummy: [],
      dayDummy: [],
      switches: false,
      check: true,
      promotion: [],
      data_mode:[],
      data_mode_typemanual: [],
      // msg: 'Welcome to Your Vue.js App',
      // url : 'https://www.youtube.com/embed/8IvK0QTW8gU',
    };
  },  
  async mounted() {
      this.$isLoading(true)

    this.dynamic_qr_checker();
    let parm = this.$route.params.id;
    // console.log(parm);
    

    if (parm === "null") {
      // console.log('สร้าง');
      // console.log(this.$route.params.id);
      axios({
        method: "post",
        url:
          JwService.getAPI() + "/api/method/justwash.OwnerApi.WashingMachines",
        data: {},
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.data.message.status == true) {
            this.$isLoading(false)

            // deviceRef.on('value', (snapshot) => {
            //   this.devices = snapshot.val();
            this.tableData = response.data.message.data.data;
            // console.log(this.tableData);
            for (const item of this.tableData) {
              if (item.dynamic_qr === 1) {
                this.dump.push({
                  name_desc: item.name_desc,
                  name: item.name,
                  check: false,
                  modes: item.modes,
                });

              }
              
            }
            //  console.log(this.dump);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // console.log("แก้ไข");

      await axios({
        method: "post",
        url:
          JwService.getAPI() + "/api/method/justwash.OwnerApi.WashingMachines",
        data: {},
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.data.message.status == true) {
            this.$isLoading(false)

            this.tableData = response.data.message.data.data;
            // console.log( 'เครื่องทั้งหมด' ,this.tableData );
            for (const item of this.tableData) {
              if (item.dynamic_qr === 1) {
                this.dump.push({
                  name_desc: item.name_desc,
                  name: item.name,
                  check: false,
                  modes: item.modes,
                });
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });

      await axios({
        method: "post",
        url: JwService.getAPI() + "/api/method/justwash.OwnerApi.get_promotion",
        data: {
          name: parm,
        },
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          this.$isLoading(false)

          const wmObj = response.data.message.data.promotion_washing_machine;
          const dayObj = response.data.message.data.week_job;

          if (response.data.message.data.enable === 1) {
            this.switches = true;
          } else {
            this.switches = false;
          }

          let start = response.data.message.data.start_time.length;
          let end = response.data.message.data.end_time.length;

          if (start < 2) {
            this.dateStart =
              "0" + response.data.message.data.start_time + ".00";
          } else {
            this.dateStart = response.data.message.data.start_time + ".00";
          }
          if (end < 2) {
            this.dateEnd = "0" + response.data.message.data.end_time + ".00";
          } else {
            this.dateEnd = response.data.message.data.end_time + ".00";
          }

          

          for (let i = 0; i < this.dump.length; i++) {
            for (let j = 0; j < wmObj.length; j++) {
              if (this.dump[i].name === wmObj[j].washing_machine_id) {

                this.dump[i].check = true;
              }
            }
          }

          for (let k = 0; k < this.day.length; k++) {
            for (let m = 0; m < dayObj.length; m++) {
              if (this.day[k].textEng === dayObj[m].day_of_week) {
                // console.log('วันเหมือน');
                this.day[k].check = true;
              }
            }
          }

          // console.log(this.dump);
           this.price = "" + response.data.message.data.discount_percent;
              if (this.price == '0') {
              this.price = 'manual';
              for (const wmo of wmObj) {
                    // console.log(wmo);
              
              for (const ite in JSON.parse(wmo.customprices)) {
                  // console.log(ite);
                // console.log(ite);
                  this.data_mode[wmo.washing_machine_id + '_' + ite] =  JSON.parse(wmo.customprices)[ite]; 
                  // console.log(wmo.washing_machine_id + '_' + ite +  ':' + JSON.parse(wmo.customprices)[ite]);
              }
          }
              }
          this.namePro = response.data.message.data.promotion_name;

          this.isLimitDate =  response.data.message.data.is_limit_date
          // this.date_limit[0] = response.data.message.data.start_date
          // this.date_limit[1] = response.data.message.data.end_date

          this.date_limit = [ new Date(response.data.message.data.start_date), new Date(response.data.message.data.end_date) ]

          // console.log(this.price);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  methods: {
    submit: function () {
      // console.log(this.data_mode)
      // console.log(this.data_mode['afd42137ae_M018'])
      // this.data_mode['afd42137ae_M018'] = 8989


      let parm = this.$route.params.id;
      this.data_mode_typemanual = [];
      let data_washing_lenght = 0;
      let data_mode_lenght = 0;
      let mode_in_modedata = 0;      
      let arr_check = [];
      let arr_write = [];
      var test = [];

          for (let index = 0; index < this.dump.length; index++) {
                if (this.dump[index].check === true) {
                  arr_check.push(this.dump[index].name)
                  data_washing_lenght = data_washing_lenght + 1 
                  this.dummy.push(this.dump[index].name);
                  this.data_mode_typemanual.push({name: this.dump[index].name, modes: []})
                  for (const ea of this.dump[index].modes) {
                    data_mode_lenght = data_mode_lenght + 1 
                  }
                }
          }

          

          if (this.price == 'manual') {
           
            for (let index = 0; index < this.data_mode_typemanual.length; index++) {
               const obj = {};
               
                for (const key in this.data_mode) {
                  // console.log(key.substring(0, key.search("_")));
                
                  if (this.data_mode_typemanual[index].name == key.substring(0, key.search("_"))) {
                    //  console.log(parseInt(this.data_mode[key]));
                     obj[key.substring(key.search("_")+1)] = parseInt(this.data_mode[key]);
                    //  arr_check.push(key.substring(0, key.search("_")));
                     
                  }
             }
                 this.data_mode_typemanual[index].modes.push(obj);   
            }

              for (const tem in this.data_mode) {
                if (this.data_mode[tem]+''.trim().length > 0) {
                       mode_in_modedata = mode_in_modedata + 1;
                        if(arr_write.indexOf(tem.substring(0, tem.search("_"))) === -1) {
                          arr_write.push(tem.substring(0, tem.search("_")));
                        }
                } 
            }
            
           

            for (let index = 0; index < arr_write.length; index++) {
               const found = arr_check.find(element => element == arr_write[index]);
               if (found !== undefined) {
                  test.push(arr_write[index]);
               }
            }
           
            this.dummy = this.data_mode_typemanual;
            //  console.log('test', JSON.stringify(test));
            // console.log(JSON.stringify(arr_write));
            // console.log(JSON.stringify(arr_check));
            

            if (JSON.stringify(test) !== JSON.stringify(arr_write) || data_mode_lenght !== mode_in_modedata ) {
               alert('กรุณาตรวจสอบความถูกต้อง')
               return '';
            }
              
          }
     
      
   
      for (let index = 0; index < this.day.length; index++) {
        if (this.day[index].check === true) {
          this.dayDummy.push(this.day[index].textEng);
        }
      }

      // let one = false;
      // let two = false;
      let one = true;
      let two = true;
  

      // if (parseInt(this.dateEnd) == 0 && parseInt(this.dateEnd) == 0) {
      //   one = true;
      // } 
      // else {
      // if (parseInt(this.dateEnd) <= parseInt(this.dateStart)) {
      //         alert("กรุณาเลือกเวลาให้ถูกต้อง");
      //         this.dummy = [];
      //         this.dayDummy = [];
      //       } else {
      //         one = true;
      //       }
      // }
    

      if (
        this.namePro === null || this.namePro.length == 0 ||
        this.price === null ||
        this.dummy.length === 0 ||
        this.dayDummy.length === 0
      ) {
        alert("กรุณากรอกข้อมูลให้ครบ");
        this.dummy = [];
        this.dayDummy = [];
      } else {
        two = true;
      }

      // ====== กดสร้าง =========

      if (one === true && two === true && parm === "null") {
         if (this.price !== 'manual') {
            this.price = parseInt(this.price);
         }
        const data = {
          name: "",
          enable: 0,
          start_time: parseInt(this.dateStart),
          end_time: parseInt(this.dateEnd),
          discount_percent: this.price,
          promotion_washing_machine: JSON.stringify(this.dummy),
          week_job: JSON.stringify(this.dayDummy),
          owner: null,
          promotion_name: this.namePro,

          is_limit_date : this.isLimitDate,
          start_date :  moment(this.date_limit[0]).format('YYYY-MM-DD'), 
          end_date :  moment(this.date_limit[1]).format('YYYY-MM-DD'),

        };

        // console.log(JSON.stringify(data));
        // console.log(data)
        // return 

        axios({
          method: "post",
          url:
            JwService.getAPI() +
            "/api/method/justwash.OwnerApi.update_promotion",
          // url: 'http://51ed42bc535e.ngrok.io/api/method/justwash.OwnerApi.update_promotion',
          data: data,
          headers: {
            Authorization: "Token " + localStorage.getItem("accessToken"),
          },
        })
          .then((response) => {
            // console.log(response);
            if (response.data.message.status == true) {
              this.washingData = response.data.message.data.data;
              alert("บันทึกเสร็จสิ้น");
              this.$router.push("/promotion");
            } else {
               alert(response.data.message.status)
            }
          
          })
          .catch((error) => {
            console.log(error);
            this.$router.push("/login");
          });

        
      }

      let value_enable;
      if (this.switches === false) {
        value_enable = 0;
      } else {
        value_enable = 1;
      }

      // ====== กดอัพเดท =========

      if (one === true && two === true && parm !== "null") {
        if (this.price !== 'manual') {
            this.price = parseInt(this.price);
         }
        const data = {
          name: this.$route.params.id,
          enable: value_enable,
          start_time: parseInt(this.dateStart),
          end_time: parseInt(this.dateEnd),
          discount_percent: this.price,
          promotion_washing_machine: JSON.stringify(this.dummy),
          week_job: JSON.stringify(this.dayDummy),
          owner: null,
          promotion_name: this.namePro,

          is_limit_date : this.isLimitDate,
          start_date :  moment(this.date_limit[0]).format('YYYY-MM-DD'), 
          end_date :  moment(this.date_limit[1]).format('YYYY-MM-DD'),
        };
        // console.log(JSON.stringify(data));
        console.log(data)
        // return

        axios({
          method: "post",
          url:
            JwService.getAPI() +
            "/api/method/justwash.OwnerApi.update_promotion",
          // url: 'http://51ed42bc535e.ngrok.io/api/method/justwash.OwnerApi.update_promotion',
          data: data,
          headers: {
            Authorization: "Token " + localStorage.getItem("accessToken"),
          },
        })
          .then((response) => {
            // console.log(response);

            if (response.data.message.status == true) {
              this.washingData = response.data.message.data.data;
                alert("แก้ไขเสร็จสิ้น");
                this.$router.push("/promotion");
              // console.log(this.washingData);
              //   // this.$router.push('/setting/'+this.$route.params.id);
            } else {
                alert('เกิดข้อผิดพลาด ' +response.data.message.status_message)
            }
            //   this.$router.push('/login');
            // }
          })
          .catch((error) => {
            console.log(error);
            // this.$router.push('/login');
          });

        // console.log('data', data);
      
      }

      this.dummy = [];
      this.dayDummy = [];
    },

    allSelect: function () {
      // console.log(this.all);
      if (this.all === false) {
        for (let index = 0; index < this.dump.length; index++) {
          this.dump[index].check = true;
        }
      }
      if (this.all === true) {
        for (let index = 0; index < this.dump.length; index++) {
          this.dump[index].check = false;
        }
        // console.log(this.dump);
      }
    },
    allSelectDay: function () {
      // console.log(this.all);
      if (this.allDay === false) {
        for (let index = 0; index < this.day.length; index++) {
          this.day[index].check = true;
        }
      }
      if (this.allDay === true) {
        for (let index = 0; index < this.day.length; index++) {
          this.day[index].check = false;
        }
        // console.log(this.day);
      }
    },
    booleanData(data) {
      // console.log(data);
      // let enable;
      // if (data === true) {
      //       enable = 0
      //   } else  {
      //       enable = 1
      //   }
      //   console.log('enable', enable);
      //     axios({
      //         method: 'post',
      //         url: JwService.getAPI()+'/api/method/justwash.OwnerApi.enable_promotion',
      //         data: {
      //             name: this.$route.params.id,
      //             enable : enable
      //         },
      //         headers: {
      //         'Authorization' : 'Token '+localStorage.getItem('accessToken')
      //         }
      //       }).then((response) => {
      //          if (response.data.message.status == true) {
      //             console.log(response.data.message.data);
      //             this.tableData = response.data.message.data;
      //             for (let index = 0; index < this.tableData.length; index++) {
      //                 if (this.tableData[index].enable === 1) {
      //                     this.tableData[index].enable = true;
      //                 } else {
      //                     this.tableData[index].enable = false;
      //                 }
      //                 }
      //          }
      //         }).catch(error => {
      //              console.log(error);
      //              this.$router.push('/login');
      //         });
    },
    async dynamic_qr_checker() {
      await axios({
        method: "post",
        url:
          JwService.getAPI() +
          "/api/method/justwash.OwnerApi.dynamic_qr_checker",
        data: {},
        headers: {
          Authorization: "Token " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          // if (response.data.message == true) {
          this.check = response.data.message;
          // console.log('this.check',  this.check);
          // }
        })
        .catch((error) => {
          console.log(error);
          // this.$router.push('/login');
        });
    },
    isNumber: function(evt) {
      // console.log(evt);
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onChangeProtime: function(){
      console.log("Chnage Time Pro", this.dateEnd, this.dateStart)
      
      let start_time= parseInt(this.dateStart)
      let end_time= parseInt(this.dateEnd)

      if(start_time-end_time<0){
        this.promotion_time_message = ""
      }else if(start_time-end_time>=0){
        this.promotion_time_message = "การตั้งค่าเวลาสิ้นสุดจะอนุญาตให้สามารถดำเนินการต่อในวันถัดไปได้ โดยไม่คำนึงถึงวันในสัปดาห์"
      }

    },
    initCustomPrice: function(data){
      console.log("v inits")
      data = {
        get() {
          //your validation
          return 99;
        },
        set(val) {
          this.fromDate = val;
        },
      }
      // data.set(99)

    } 
  },
};
</script>
<style>
#ads {
  /* background-color: gray; */
  position: absolute;
  z-index: 3;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 100%;
  /* opacity: 0.5; */
}

#box {
  position: fixed;
  top: 10%;
  width: 85%;
  padding: 10px;
  margin: 0;
  /* background-color: gray; */
}

#fontInBox {
  font-size: 40px;
  color: white;
  text-align: center;
  background-color: black;
  opacity: 0.5;
}

#vdo {
  display: block;
  margin: auto;
  height: 300px;
  width: 600px;
  background-color: rgba(0, 255, 255, 0);
}

@media only screen and (max-width: 800px) {
  #box {
    position: fixed;
    top: 15%;
    width: 70%;
    /* padding: 10px; */
    margin: 0;
    /* background-color: blue; */
  }

  #fontInBox {
    font-size: 40px;
    color: white;
    text-align: center;
  }

  #vdo {
    text-align: center;
    height: 400px;
    width: 480px;
    opacity: 1 !important;
  }
}
@media only screen and (max-width: 550px) {
  #box {
    position: fixed;
    top: 15%;
    width: 100%;
    padding: 10px;
    margin: 0;
    /* background-color: green; */
    text-align: center;
  }
  #fontInBox {
    font-size: 40px;
    color: white;
    text-align: center;
  }

  #vdo {
    margin-left: 0px;
    height: 400px;
    width: 500px;
  }
}
@media only screen and (max-width: 450px) {
  #box {
    position: fixed;
    top: 15%;
    width: 100%;
    /* background-color: yellow; */
    /* text-align: center; */
  }

  #fontInBox {
    font-size: 40px;
    color: white;
    text-align: center;
  }

  #vdo {
    height: 250px;
    width: 350px;
  }
}
@media only screen and (max-width: 360px) {
  #box {
    position: fixed;
    top: 15%;
    width: 100%;
    padding: 10px;
    /* background-color: yellow; */
    /* text-align: center; */
    /* display: table-cell; */
    /* text-align: center; */
    /* vertical-align: middle; */
  }
  #fontInBox {
    font-size: 40px;
    color: white;
    text-align: center;
  }

  #vdo {
    height: 250px;
    width: 330px;
  }
}
@media only screen and (max-width: 320px) {
  #box {
    position: fixed;
    top: 15%;
    width: 100%;
    padding: 10px;
    /* background-color: yellow; */
    /* text-align: center; */
    /* display: table-cell; */
    /* text-align: center; */
    /* vertical-align: middle; */
  }
  #fontInBox {
    font-size: 40px;
    color: white;
    text-align: center;
  }

  #vdo {
    height: 250px;
    width: 300px;
  }
}
</style>
